import controller from "@ctrl/controller";
import type {
  Controller,
  MandateDocument,
  MetricsObjectSource,
} from "@ctrl/controller-rpc";

const { makeBlockId } = controller;

export async function createGuidePage(guideId: string, controller: Controller) {
  const options: { document: MandateDocument; source: MetricsObjectSource } = {
    document: { id: { kind: "page", id: guideId } },
    source: "other",
  };

  await controller.document.append(options.document, {
    id: makeBlockId(),
    type: "embed",
    content: "https://youtu.be/-fy46SWvFUo",
  });

  await controller.document.append(options.document, {
    id: makeBlockId(),
    type: "paragraph",
    content:
      "We've put together a quick guide for you to get started with Routine.",
  });

  await controller.document.append(options.document, {
    id: makeBlockId(),
    type: "paragraph",
    content:
      "This guide has been structured in **4 levels** but you can easily skip what feels natural:",
  });

  await controller.document.append(options.document, {
    id: makeBlockId(),
    type: "bullet",
    list_type: "ordered",
    content: "Fundamentals",
  });

  await controller.document.append(options.document, {
    id: makeBlockId(),
    type: "bullet",
    list_type: "ordered",
    content: "Advanced",
  });

  await controller.document.append(options.document, {
    id: makeBlockId(),
    type: "bullet",
    list_type: "ordered",
    content: "AI",
  });

  await controller.document.append(options.document, {
    id: makeBlockId(),
    type: "bullet",
    list_type: "ordered",
    content: "Teamwork",
  });

  await controller.document.append(options.document, {
    id: makeBlockId(),
    type: "callout",
    icon: { kind: "emoji", emoji: "ℹ️" },
    content:
      "For each tutorial, click to open it and watch the video before marking it as watched.",
  });

  await controller.document.append(options.document, {
    id: makeBlockId(),
    type: "query",
    content: `tutorials sort asc by ['Title'] index by 'Level' as _routine_source_database
select (_routine_source_database as _routine_source_database
        select ({_routine: _routine_source_database.?_routine,
                 Watched: 'Watched', Title: 'Title', Notes: 'Notes'}))`,
  });
}
